import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/business/commonLogin/login",
    method: "post",
    data
  });
}
export function getUserInfo() {
  return request({
    url: "/business/commonStaff/info",
    method: "get"
  });
}

export function create(data) {
  return request({
    url: "/business/businessManageStructure",
    method: "post",
    data
  });
}
export function update(data) {
  return request({
    url: "/business/businessManageStructure",
    method: "put",
    data
  });
}
export function list(data) {
  return request({
    url: "/business/businessManageStructure/list",
    method: "post",
    data
  });
}
export function getById(data) {
  return request({
    url: "/business/businessManageStructure",
    method: "get",
    params: data
  });
}
export function del(data) {
  return request({
    url: "/business/businessManageStructure",
    method: "delete",
    params: data
  });
}
// 个人服务用-机构名称列表
export function businessNameList(data) {
  return request({
    // url: "/consumer/business/businessNameList",
    url:"/consumer/business/businessLinkNameList",
    method: "get",
    params: data
  });
}



// WEBPACK FOOTER //
// ./src/api/business.js